import styled from 'styled-components'
import { customMedia } from './common'

const LayoutWrap = styled.div`
  display: block;
  width: 100%;

`
const LayoutSubPage = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  min-width: 328px;
  white-space: nowrap;
  ${customMedia.lessThan('tablet_cut_line')`
    padding: 0 16px;
    margin: 0;
  `}
  ${customMedia.lessThan('mobile')`
    overflow-x:auto;
    width: 328px;
    padding: 0;
    margin: 0 auto;
  `}
`

export { LayoutWrap, LayoutSubPage }
